import './index.scss'
import BlogItems from '../blog-items'
import BlogImg from '../../../assets/images/blog-img1.png'
import BlogImg2 from '../../../assets/images/blog-img2.png'
import BlogImg3 from '../../../assets/images/blog-img3.png'
import {useAnimation, motion} from "framer-motion"
import { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";

const blogs = [
    {id:"blog1", title:"Gamification in HRMS: Boosting Employee Engagement and Performance", description:"In today’s fast-paced work environment, where technology merges seamlessly with human resource management, the power of gamification is reshaping employee engagement and performance.", image:BlogImg},
    {id:"blog2", title:"Boost Your Productivity: Walkzero Shares 6 Hacks to Supercharge ....", description:"In today’s fast-paced work environment, productivity is key to success. Whether you’re tackling a project or managing a team, optimizing your workflow can make all the difference.", image:BlogImg2},
    {id:"blog3", title:"Key HR Processes That Build Stronger Businesses: Enhancing Organization ....", description:"Human Resources (HR) is an integral function within any organization, responsible for managing and developing the most valuable asset: its people. In today’s competitive......", image:BlogImg3},
]

const RecentBlogs = () => {

    const ctrls = useAnimation();

    const { ref, inView } = useInView({
        threshold: 0.5,
        triggerOnce: true,
      });

    useEffect(() => {
        if (inView) {
            ctrls.start("visible");
        }
        if (!inView) {
            ctrls.start("hidden");
        }
    }, [ctrls, inView])

    const [blogList, setBlogList] = useState(blogs);

    // const getBlogs = async() => {
    //     const url = 'https://09ee-2406-7400-bb-a4b3-157f-8c04-b59c-751b.ngrok-free.app/blog/'
    //     const response = await fetch(url)
    //     console.log(response)
    //     if(response.ok){
    //         const data = await response.json()
    //         setBlogList(data)
    //     }
    // }

    // useEffect(() => {
    //     getBlogs()
    // }, [])

    // console.log(blogList)

    const container = {
        hidden:{
            opacity:1
        },
        visible: (i = 1) => ({
            opacity:1,
            transition:{
                staggerChildren: 0.08,
                delayChildren: 0.04 * i,
            }
        }),
    }

    const child = {
        visible:{
            y:0,
            opacity:1,
            transition:{
                duration:1, 
                type:"tween",
                ease:"easeIn"
            }
        },
        hidden:{
            y:50,
            opacity:0
        }
    }

    return(
        <motion.div ref={ref} variants={container} initial="hidden" animate={ctrls} className='d-flex flex-column justify-conent-center align-items-center align-self-center recent-blog-cont m-t-50 m-b-50'>
            <motion.div variants={child} className='d-flex flex-row justify-content-between w-100 align-items-center'>
                <p className='col-container-font text-22 font-weiht-6'>Recent <span className='col-secondary'>blogs</span></p>
                <hr className='line-btm' />
                <a href="https://medium.com/@walkzero" target="_blank" rel="noopener noreferrer" className='col-secondary font-1 font-weight-5 text-12 decoration'>View more</a>
            </motion.div>
            <motion.div variants={child} className='d-flex flex-row justify-content-between align-items-center w-100 m-t-40 blog-cont'>
                {blogList.map(each => {
                    return <BlogItems key={each.id} item={each}/>
                })} 
            </motion.div>
        </motion.div>
    )
}

export default RecentBlogs